import "./CommercialCleaningCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import CaseStudyHero from "./sections/CaseStudyHero";
import Strategy from "./sections/Strategy";
import CaseResults from "./sections/CaseResults";
import Footer from "@/reusable_sections/Footer";
export default function CommercialCleaningCaseStudyPage() {
  return <div>
      <Header />
      <CaseStudyHero />
      <Strategy />
      <CaseResults />
      <Footer />
    </div>;
}